module.exports = __webpack_public_path__ + "static/WSYSIWGImage-78e436f0cf2ca1f38fd6398f15448859.png";